import {
  SET_CG_ACTIVE_COLUMN,
  TOGGLE_CG_NUMBER,
  TOGGLE_CG_EXTRA_NUMBER,
  CLEAR_CG_COLUMN,
  CLEAR_CG_SLIP,
  SET_AUTO_CG_SELECTIONS,
  SET_CHANGE_GAMES_DEFAULT_COLUMNS,
  PLAY_CHANCE_GAMES_COUPON_REQUEST,
  PLAY_CHANCE_GAMES_COUPON_SUCCESS,
  PLAY_CHANCE_GAMES_COUPON_FAILURE,
  SET_CHANCE_GAMES_PLAY_DATA_FROM_LOCAL_STORAGE,
  GENERATE_CG_COUPONS_REQUEST,
  GENERATE_CG_COUPONS_SUCCESS,
  GENERATE_CG_COUPONS_FAILURE,
  SET_CG_GENERATED_COLUMNS_TO_SLIP
} from 'Store/constants';

import { gameTypeConverter } from 'Store/constants/sportTypes';

const initialState = {
  playData: {
    data: {}, isFetched: false, isLoading: false, error: null
  },
  isLoading: false,
  error: null,
  moneyLotto: {},
  numbersLotto: {},
  tenNumbers: {},
  luckyBalls: {},
  generatedCoupons: {
    data: [], isFetched: false, isLoading: false, error: null
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_CHANCE_GAMES_PLAY_DATA_FROM_LOCAL_STORAGE: {
      return action.payload?.cgPlay || initialState;
    }

    case TOGGLE_CG_NUMBER: {
      const { gameType, number, limit } = action.payload;
      const stateKey = gameTypeConverter[gameType];


      let selectedNumbers = state[stateKey].selections.find(column => column.columnName === state[stateKey].activeColumnName)?.selection || [];
      let newSelections = state[stateKey].selections;

      if (selectedNumbers.some(item => item === number)) {
        newSelections = state[stateKey].selections.map(column => column.columnName !== state[stateKey].activeColumnName ? column : ({
          ...column,
          selection: selectedNumbers.filter(item => item !== number)
        }));
      } else if (selectedNumbers.length < limit) {
        newSelections = state[stateKey].selections.map(column => column.columnName !== state[stateKey].activeColumnName ? column : ({
          ...column,
          selection: [...selectedNumbers, number]
        }));
      }

      return {
        ...state,
        [stateKey]: {
          ...state[stateKey],
          selections: newSelections
        }
      };
    }

    case TOGGLE_CG_EXTRA_NUMBER : {
      const { gameType, number, limit } = action.payload;
      const stateKey = gameTypeConverter[gameType];

      let selectedNumbers = state[stateKey].selections.find(column => column.columnName === state[stateKey].activeColumnName)?.extraSelection || [];
      let newSelections = state[stateKey].selections;

      if (selectedNumbers.some(item => item === number)) {
        newSelections = state[stateKey].selections.map(column => column.columnName !== state[stateKey].activeColumnName ? column : ({
          ...column,
          extraSelection: []
        }));
      } else if (selectedNumbers.length < limit) {
        newSelections = state[stateKey].selections.map(column => column.columnName !== state[stateKey].activeColumnName ? column : ({
          ...column,
          extraSelection: [number]
        }));
      }

      return {
        ...state,
        [stateKey]: {
          ...state[stateKey],
          selections: newSelections
        }
      };
    }

    case SET_CG_ACTIVE_COLUMN: {
      const stateKey = gameTypeConverter[action.payload.gameType];

      return {
        ...state,
        [stateKey]: {
          ...state[stateKey],
          activeColumnName: action.payload.columnName
        }
      };
    }

    case CLEAR_CG_COLUMN: {
      const stateKey = gameTypeConverter[action.payload.gameType];

      return {
        ...state,
        [stateKey]: {
          ...state[stateKey],
          selections: state[stateKey].selections.map(column => column.columnName === action.payload.columnName ? ({
            ...column,
            selection: [],
            extraSelection: []
          }) : column)
        }
      };
    }

    case CLEAR_CG_SLIP: {
      const stateKey = gameTypeConverter[action.payload.gameType];

      return {
        ...state,
        [stateKey]: {
          ...state[stateKey],
          selections: state[stateKey].selections.map(column => ({
            ...column,
            selection: [],
            extraSelection: []
          }))
        }
      };
    }

    case SET_AUTO_CG_SELECTIONS: {
      const stateKey = gameTypeConverter[action.payload.gameType];

      return {
        ...state,
        [stateKey]: {
          ...state[stateKey],
          selections: state[stateKey].selections.map(column =>
            column.columnName === action.payload.columnName ? action.payload.newColumn : column)
        }
      };
    }

    case SET_CHANGE_GAMES_DEFAULT_COLUMNS: {
      const { gameType, maxColumnCount } = action.payload;
      const stateKey = gameTypeConverter[gameType];

      return {
        ...state,
        [stateKey]: {
          activeColumnName: 1,
          selections: [...Array(maxColumnCount)].map((column, index) => ({
            columnName: index + 1,
            selection: [],
            extraSelection: []
          }))
        }
      };
    }

    case GENERATE_CG_COUPONS_REQUEST:
      return {
        ...state,
        generatedCoupons: {
          data: [],
          isLoading: true,
          error: null
        }
      };

    case GENERATE_CG_COUPONS_SUCCESS:
      return {
        ...state,
        generatedCoupons: {
          data: action.payload,
          isLoading: false,
          error: null
        }
      };

    case GENERATE_CG_COUPONS_FAILURE:
      return {
        ...state,
        generatedCoupons: {
          data: [],
          isLoading: false,
          error: action.payload
        }
      };
    
    case SET_CG_GENERATED_COLUMNS_TO_SLIP: {
      const { gameType, coupons, totalColumnCount } = action.payload;
      const stateKey = gameTypeConverter[gameType];
      
      let selectionsArr = [];
      let columnsCounter = 1;

      coupons.forEach(coupon => {
        Object.keys(coupon.columns).forEach(key => {
          selectionsArr.push({
            columnName: columnsCounter++,
            selection: coupon.columns[key].selections,
            extraSelection: coupon.columns[key].optionals
          });
        });
      });

      if ((columnsCounter - 1) < totalColumnCount) {
        let restOfSelections = [...Array(totalColumnCount - (columnsCounter - 1))].map((column, index) => ({
          columnName: columnsCounter + index,
          selection: [],
          extraSelection: []
        }));

        selectionsArr = [...selectionsArr, ...restOfSelections];
      }

      return {
        ...state,
        [stateKey]: {
          activeColumnName: 1,
          selections: selectionsArr
        }
      };
    }

    case PLAY_CHANCE_GAMES_COUPON_REQUEST:
      return {
        ...state,
        playData: {
          isLoading: true,
          isFetched: false,
          error: null
        }
      };

    case PLAY_CHANCE_GAMES_COUPON_SUCCESS:
      return {
        ...state,
        playData: {
          ...state.data,
          isLoading: false,
          isFetched: true,
          error: null
        }
      };

    case PLAY_CHANCE_GAMES_COUPON_FAILURE:
      return {
        ...state,
        playData: {
          ...state.data,
          isLoading: false,
          isFetched: true,
          error: action.payload
        }
      };

    default:
      return state;
  }
};
